import React from 'react';
import MailNotificationItem from './MailNotificationItem';
import type { OrganizationUserType } from '../../../types/user';

interface MailNotificationProps {
  organizationUsers: OrganizationUserType[];
}

const MailNotification = React.memo(({ organizationUsers }: MailNotificationProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <div className="control-notification">
      {organizationUsers.length > 0 ? organizationUsers.map((orgUser, idx) => <MailNotificationItem key={'organization-user-item-' + idx} organizationUser={orgUser} />) : <>-</>}
    </div>
  );
});

MailNotification.displayName = 'MailNotification';
export default MailNotification;
